var v1="<div class=\"map\" ng-attr-id=\"{{vm.mapId}}\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbMapTemplate.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbMap/lbMapTemplate.html
// module id = 319
// module chunks = 0